import { Col, Row } from 'antd';
import React, { ReactNode } from 'react';
import styles from './AnalyticsLayout.module.scss';

interface AnalyticsSectionProps {
  plotInputContent?: ReactNode;
  updateContent?: ReactNode;
  chartContent?: ReactNode;
  additionalContent?: ReactNode;
  isLoading?: boolean;
}

export const AnalyticsSection: React.FC<AnalyticsSectionProps> = ({
  plotInputContent,
  updateContent,
  chartContent,
  additionalContent,
  isLoading = false,
}) => {
  return (
    <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <div style={{ borderBottom: '2px solid #f0f0f0' }}>
        <Row style={{ height: '100%' }} gutter={[0, 0]}>
          <Col flex='1' className={styles.plotInputSection}>
            <div className={styles.plotInputSectionContent}>
              {plotInputContent}
            </div>
          </Col>

          <Col flex='0 0 240px' className={styles.updateSection}>
            <div className={styles.updateSectionContent}>
              {updateContent || <div>No actions</div>}
            </div>
          </Col>
        </Row>
      </div>

      <Row style={{ flex: 1 }} gutter={[0, 0]}>
        <Col flex='1' className={styles.chartSection}>
          <div className={styles.chartSectionContent}>
            <div
              className={`${styles.chartContent} ${
                isLoading ? styles.loading : ''
              }`}
            >
              {chartContent || <div>No chart available</div>}
            </div>
          </div>
        </Col>

        <Col flex='0 0 240px' className={styles.additionalSection}>
          <div className={styles.additionalSectionContent}>
            {additionalContent}
          </div>
        </Col>
      </Row>
    </div>
  );
};
